<div class="min-w-96 pb-4">
    <h1
        class="text-center text-2xl font-medium"
        mat-dialog-title>
        Create schedule
    </h1>
    <mat-dialog-content class="!pb-0">
        <form
            class="flex flex-col"
            [formGroup]="form">
            <mat-form-field>
                <mat-label>Name</mat-label>
                <input
                    matInput
                    formControlName="name" />
            </mat-form-field>
            <mat-form-field>
                <mat-label>Reapeat type</mat-label>
                <mat-select formControlName="repeat">
                    @for (keyValue of QuestRepeatType | appEnumKeyValue; track $index) {
                        <mat-option [value]="keyValue.value">{{ keyValue.key }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Retention days</mat-label>
                <mat-chip-grid
                    #grid
                    formControlName="retentionDays">
                    @for (day of form.controls.retentionDays.value; track day) {
                        <mat-chip-row (removed)="removeRetentionDay(day)">
                            {{ day }}
                            <button matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                    }
                </mat-chip-grid>
                <input
                    placeholder="Retention day"
                    [matChipInputFor]="grid"
                    (matChipInputTokenEnd)="addRetentionDay($event)" />
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        <button
            mat-flat-button
            color="primary"
            [disabled]="form.invalid"
            (click)="close()">
            Create
        </button>
    </mat-dialog-actions>
</div>
